/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDomainsResource
 */
export interface OrganizationDomainsResource {
    /**
     * 
     * @type {Array<string>}
     * @memberof OrganizationDomainsResource
     */
    emailDomains: Array<string>;
}

/**
 * Check if a given object implements the OrganizationDomainsResource interface.
 */
export function instanceOfOrganizationDomainsResource(value: object): value is OrganizationDomainsResource {
    if (!('emailDomains' in value) || value['emailDomains'] === undefined) return false;
    return true;
}

export function OrganizationDomainsResourceFromJSON(json: any): OrganizationDomainsResource {
    return OrganizationDomainsResourceFromJSONTyped(json, false);
}

export function OrganizationDomainsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDomainsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'emailDomains': json['emailDomains'],
    };
}

export function OrganizationDomainsResourceToJSON(value?: OrganizationDomainsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'emailDomains': value['emailDomains'],
    };
}

